import React, {Component} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {Link} from 'react-router-dom';
import  * as settings from '../../services/settings';
import EngineInfo from "../EngineInfo/EngineInfo";

export default class Sidebar extends Component {

	static propTypes = {
		projects: PropTypes.array,
		selectedProject: PropTypes.object,
		selectProject: PropTypes.func.isRequired
	};

	render() {
		const projects = _.map(this.props.projects, (project, key) => {
			return (
				<li className={this.props.selectedProject && project.name === this.props.selectedProject.name ? 'active' : 'inactive'} key={key}>
					<Link to={'/show/' + encodeURIComponent(project.name)}>
						<span className="sidebar-mini-icon">{project.type[0]}</span>
						<span className="sidebar-normal" style={{overflow: 'hidden'}}> {project.name}</span>
					</Link>
				</li>
			);
		});


		return (
			<div className="sidebar" data-color="internezzo" data-active-color="internezzo">
				<div className="logo">
					<Link to="/" className="simple-text logo-mini">
						<div className="logo-image-small">
							<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44">
								<g transform="translate(-68,-68)" fill="#fff">
									<path d="M88.1 81.9h5v18h-5z"/>
									<path
										d="M94.1 70.8H94v4.8h.1c7.1 1.6 12.3 8 12.3 15.3 0 8.6-7 15.6-15.6 15.6s-15.6-7-15.6-15.6c0-7.3 5.2-13.7 12.3-15.3h.1v-4.8h-.1c-9.8 1.6-16.9 10.1-16.9 20 0 11.2 9.1 20.3 20.3 20.3 11.2 0 20.3-9.1 20.3-20.3-.1-9.9-7.2-18.3-17.1-20z"/>
								</g>
							</svg>
						</div>
					</Link>
					<Link to="/" className="simple-text logo-normal">
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 232 44">
							<g transform="translate(-68,-68)" fill="#fff">
								<path
									d="M124.1 78.3v-4.6h5.1v4.6h-5.1zm5.1 3.8V104h-5.1V82.1h5.1zM134.6 104V82.1h4.9v2.5c.9-.8 1.9-1.5 2.8-2 .9-.6 1.9-.8 2.9-.8 1.6 0 2.7.4 3.5 1.3.8.9 1.2 2.3 1.2 4.3V104h-5.1V87.9c0-.7-.1-1.3-.4-1.7-.3-.4-.8-.7-1.4-.7-.5 0-1.1.2-1.6.6-.6.4-1.1.9-1.6 1.3V104h-5.2zM153.4 86.5v-4.4h2v-5h4.9v5h3.5v4.4h-3.5v11.8c0 .5.2.9.6 1.2.4.3 1.2.4 1.9.4h1v4.3c-.5.1-1 .1-1.4.2H161c-1.7 0-3-.3-4-1s-1.5-1.8-1.5-3.4V86.5h-2.1zM172.3 94.2v2.9c0 1.1.3 1.9.8 2.4.6.5 1.3.7 2.1.7 1.1 0 1.8-.3 2.3-.9.5-.6.7-1.3.7-2.2h5.1c-.1 2.3-.9 4-2.2 5.3-1.3 1.2-3.3 1.9-5.8 1.9-1.2 0-2.3-.2-3.3-.5-1-.4-1.8-.9-2.5-1.5-.7-.7-1.2-1.5-1.6-2.4-.4-1-.6-2-.6-3.2v-7.2c0-1.2.2-2.3.6-3.2.4-1 .9-1.8 1.6-2.4.7-.7 1.5-1.2 2.5-1.5 1-.4 2.1-.5 3.3-.5 1.2 0 2.3.2 3.2.5 1 .4 1.8.9 2.5 1.5s1.3 1.4 1.7 2.3c.4.9.6 1.9.6 3.1v5.1h-11zm6-4.1v-1.2c0-1-.2-1.7-.7-2.3-.5-.6-1.2-.8-2.3-.8-1 0-1.8.3-2.3.8-.5.6-.7 1.3-.7 2.3v1.2h6zM187.9 104V82.1h4.9V85h.1c.6-1.1 1.3-1.9 2.1-2.5s1.8-.8 3.1-.8v5.5c-.4-.1-.9-.3-1.3-.4-.5-.1-.9-.2-1.4-.2-.8 0-1.5.3-1.9.8-.4.5-.6 1.1-.6 1.6v15h-5zM202 104V82.1h4.9v2.5c.9-.8 1.9-1.5 2.8-2 .9-.6 1.9-.8 2.9-.8 1.6 0 2.7.4 3.5 1.3.8.9 1.2 2.3 1.2 4.3V104h-5.1V87.9c0-.7-.1-1.3-.4-1.7-.3-.4-.8-.7-1.4-.7-.5 0-1.1.2-1.6.6-.6.4-1.1.9-1.6 1.3V104H202zM226.7 94.2v2.9c0 1.1.3 1.9.8 2.4.6.5 1.3.7 2.1.7 1.1 0 1.8-.3 2.3-.9.5-.6.7-1.3.7-2.2h5.1c-.1 2.3-.9 4-2.2 5.3-1.3 1.2-3.3 1.9-5.8 1.9-1.2 0-2.3-.2-3.3-.5-1-.4-1.8-.9-2.5-1.5-.7-.7-1.2-1.5-1.6-2.4-.4-1-.6-2-.6-3.2v-7.2c0-1.2.2-2.3.6-3.2.4-1 .9-1.8 1.6-2.4.7-.7 1.5-1.2 2.5-1.5 1-.4 2.1-.5 3.3-.5 1.2 0 2.3.2 3.2.5 1 .4 1.8.9 2.5 1.5s1.3 1.4 1.7 2.3c.4.9.6 1.9.6 3.1v5.1h-11zm5.9-4.1v-1.2c0-1-.2-1.7-.7-2.3-.5-.6-1.2-.8-2.3-.8-1 0-1.8.3-2.3.8-.5.6-.7 1.3-.7 2.3v1.2h6zM277.7 90c0-2.9.7-5 2.1-6.3 1.4-1.3 3.4-2 5.9-2 2.5 0 4.5.7 5.9 2 1.4 1.3 2.1 3.4 2.1 6.3v6.1c0 2.9-.7 5-2.1 6.3-1.4 1.3-3.4 2-5.9 2-2.5 0-4.5-.7-5.9-2-1.4-1.3-2.1-3.4-2.1-6.3V90zm5 7.4c0 .9.3 1.5.8 1.9.5.4 1.3.6 2.1.6.9 0 1.6-.2 2.2-.6.5-.4.8-1.1.8-1.9v-8.7c0-.9-.3-1.5-.8-1.9-.5-.4-1.3-.6-2.2-.6-.9 0-1.6.2-2.1.6-.6.4-.8 1.1-.8 1.9v8.7zM241.8 82.1H256v4.3l-9.2 13.2h9.2v4.4h-15v-4.3l9.2-13.2h-8.4zM260.1 82.1h14.2v4.3l-9.1 13.2h9.1v4.4h-14.9v-4.3l9.1-13.2h-8.4z"/>
								<path d="M88.1 81.9h5v18h-5z"/>
								<path
									d="M94.1 70.8H94v4.8h.1c7.1 1.6 12.3 8 12.3 15.3 0 8.6-7 15.6-15.6 15.6s-15.6-7-15.6-15.6c0-7.3 5.2-13.7 12.3-15.3h.1v-4.8h-.1c-9.8 1.6-16.9 10.1-16.9 20 0 11.2 9.1 20.3 20.3 20.3 11.2 0 20.3-9.1 20.3-20.3-.1-9.9-7.2-18.3-17.1-20z"/>
							</g>
						</svg>
					</Link>
				</div>
				<div className="sidebar-wrapper">
					<ul className="nav" style={{overflow: 'hidden'}}>
						{this.props.projects.filter(project => project.type === 'neos').length <= 0?null:(
						<li className="">
							<a data-toggle="collapse" href="#neos">
								<p>
									Neos
									<b className="caret"/>
								</p>
							</a>
							<div className="collapse show" id="neos">
								<ul className="nav">
									{
										_.map(this.props.projects.filter(project => project.type === 'neos').sort((a, b) => {
										    return (a.name.toUpperCase() < b.name.toUpperCase()) ? -1 : (a.name.toUpperCase() > b.name.toUpperCase()) ? 1 : 0;
                                        }), (project, key) => {
											return (
												<li className={this.props.selectedProject && project.name === this.props.selectedProject.name ? 'active' : 'inactive'} key={key}>
													<Link to={'/show/' + encodeURIComponent(project.name)}>
														<span className="sidebar-normal" style={{overflow: 'hidden'}}> {project.name}</span>
													</Link>
												</li>
											);
										})
									}
								</ul>
							</div>
						</li>)}
						{this.props.projects.filter(project => project.type === 'flow').length <= 0?null:(
						<li className="">
							<a data-toggle="collapse" href="#flow">
								<p>
									Flow
									<b className="caret"/>
								</p>
							</a>
							<div className="collapse show" id="flow">
								<ul className="nav">
									{
										_.map(this.props.projects.filter(project => project.type === 'flow').sort((a, b) => {
                                            return (a.name.toUpperCase() < b.name.toUpperCase()) ? -1 : (a.name.toUpperCase() > b.name.toUpperCase()) ? 1 : 0;
                                        }), (project, key) => {
											if (project.type === 'flow')
											{
												return (
													<li className={this.props.selectedProject && project.name === this.props.selectedProject.name ? 'active' : 'inactive'} key={key}>
														<Link to={'/show/' + encodeURIComponent(project.name)}>
															<span className="sidebar-normal" style={{overflow: 'hidden'}}> {project.name}</span>
														</Link>
													</li>
												);
											}
										})
									}
								</ul>
							</div>
						</li>)}
						{this.props.projects.filter(project => project.type === 'typo3').length <= 0?null:(
						<li className="nav-item">
							<a data-toggle="collapse" href="#typo3">
								<p>
									Typo3
									<b className="caret"/>
								</p>
							</a>
							<div className="collapse show" id="typo3">
								<ul className="nav">
									{
										_.map(this.props.projects.filter(project => project.type === 'typo3').sort((a, b) => {
                                            return (a.name.toUpperCase() < b.name.toUpperCase()) ? -1 : (a.name.toUpperCase() > b.name.toUpperCase()) ? 1 : 0;
                                        }), (project, key) => {
											if (project.type === 'typo3')
											{
												return (
													<li className={this.props.selectedProject && project.name === this.props.selectedProject.name ? 'active' : 'inactive'} key={key}>
														<Link to={'/show/' + encodeURIComponent(project.name)}>
															<span className="sidebar-normal" style={{overflow: 'hidden'}}> {project.name}</span>
														</Link>
													</li>
												);
											}
										})
									}
								</ul>
							</div>
						</li>)}
						{settings.showAdminFunctions() ? (
							<li className="ml-auto nav-item" style={{'backgroundColor': 'white', 'position': 'fixed', 'bottom': '0px', 'width': '260px'}}>
								<Link className='rounded text-center' to="/engine" style={{'color': 'black'}}>
									<div>
                                        <span className="nc-icon nc-settings-gear-65" style={{'color': 'black', 'verticalAlign': 'middle', 'margin': '2%'}}/>
                                        Engine
                                    </div>
                                    <div>
                                        <EngineInfo/>
                                    </div>
								</Link>
							</li>
						) : null}
					</ul>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./React/src/components/main/Sidebar.js